import { Environment } from '@rma/public/generic/util/environment';

// If you are adding something here, don't forget to add the key to: Infrastructure\public\RMA.Public.UI.Infrastructure\environment-settings.json
export const aus_environment: Environment = {
  type: 'develop',
  domain: 'ratemyagent.com.au',
  googleMapKey: 'AIzaSyCcS9T2CVJ4P_e69LgbfldbQSQ7fXMColk',
  countryCode: 'AU',
  tenantCode: 'au',
  launchDarklyClientId: '586b1ec99ae5520918642b10',
  recaptchaSiteKey: '6LcoewYTAAAAALaxzBupK5p2kI5UCj5-qifK661M',
  securePrivacyApiKey: '',
  securePrivacyId: '',
  version: '1',
  social: {
    facebookId: '345975122719921',
    facebookUrl: 'https://www.facebook.com/ratemyagent',
    twitterName: '@RateMyAgent_AUS',
    twitterUrl: 'https://twitter.com/ratemyagent_aus',
    linkedinUrl: 'http://www.linkedin.com/company/rate-my-agent',
    instagramUrl: 'https://www.instagram.com/ratemyagent_aus/',
  },
  identity: {
    client: 'rma.au.ui',
    secret: 'D1g1t@lc@stle',
    jwtEnvironment: 'AU_DevPreprod',
  },
  tracking: {
    hotjarId: undefined,
    heapAppId: '3713477979',
    facebookPixelId: undefined,
    googleTagManagerWebId: 'GTM-5JJB8R',
    googleTagManagerMegaphone: undefined,
    googleAnalytics: {
      optimizeContainerId: 'GTM-N47XBV2',
      optimizeMeasurementId: 'UA-41500364-1',
    },
    googleGlobalSiteTag: {
      adConversionId: undefined,
      phoneRevealAdConversionLabel: undefined,
      callClickAdConversionLabel: undefined,
      smsClickAdConversionLabel: undefined,
      contactFormCompletionAdConversionLabel: undefined,
    },
  },
  language: {
    lokaliseAppId: undefined,
    locale: 'en-AU',
    supportedLocales: [],
    url: 'https://language.ratemyagent.com',
  },
};

export const usa_environment: Environment = {
  ...aus_environment,
  countryCode: 'US',
  launchDarklyClientId: '586b1eef9ae5520918642b16',

  identity: {
    ...aus_environment.identity,
    client: 'rma.us.ui',
    jwtEnvironment: 'US_DevPreprod',
  },
  language: {
    ...aus_environment.language,
    locale: 'en-US',
  },
};

export const nz_environment: Environment = {
  ...aus_environment,
  countryCode: 'NZ',
  tenantCode: 'nz',
  launchDarklyClientId: '5ac2fa3cbbbd182ca18d506d',
  identity: {
    ...aus_environment.identity,
    client: 'rma.nz.ui',
    jwtEnvironment: 'NZ_DevPreprod',
  },
  language: {
    ...aus_environment.language,
    locale: 'en-NZ',
  },
};
